import { useCall } from 'apprise-frontend-core/client/call'


export const iamservice = 'iam'
export const authservice = 'auth'


export const useIAMService = () => useCall(iamservice)

export const useAuthService = () => useCall(authservice)